import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  const location = useLocation();

  if (!ready) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-stone-50">
        <div className="text-stone-400 text-sm">Caricamento…</div>
      </div>
    );
  }
  if (!user) {
    const dest = location.pathname + location.search;
    return <Navigate to={`/login?from=${encodeURIComponent(dest)}`} replace />;
  }
  return children;
}
